var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    { staticClass: "grouprow rounded interactable" },
    _vm._l(_vm.columns, function (col) {
      return _c(
        "td",
        { key: col.toString() },
        [
          typeof col === "string"
            ? [
                col.indexOf("relative") === -1
                  ? [
                      _vm._v(
                        _vm._s(
                          _vm.data[col] != null
                            ? _vm.data[col].toLocaleString()
                            : _vm.$t("results.groupBy.groupNameWithoutValue")
                        )
                      ),
                    ]
                  : [
                      _vm._v(
                        _vm._s(
                          _vm.data[col] != null
                            ? _vm.frac2Percent(
                                typeof _vm.data[col] === "string"
                                  ? 0
                                  : _vm.data[col]
                              )
                            : _vm.$t("results.groupBy.groupNameWithoutValue")
                        )
                      ),
                    ],
              ]
            : _c("div", { staticClass: "progress group-size-indicator" }, [
                _c(
                  "div",
                  {
                    staticClass: "progress-bar progress-bar-primary",
                    style: {
                      "min-width": _vm.data[col[0]]
                        ? _vm.frac2Percent(
                            _vm.dataCol0(col) / _vm.maxima[col[0]]
                          )
                        : "100%",
                      opacity: _vm.data[col[0]] ? 1 : 0.5,
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.data[col[1]]
                          ? (_vm.data[col[1]] ?? "").toLocaleString()
                          : _vm.$t("results.groupBy.groupNameWithoutValue")
                      )
                    ),
                  ]
                ),
              ]),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }